/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */
import { Dispatch, SetStateAction, useRef, useState } from "react";
import "./DateFilter.css";
import { DateFilterValues } from "../../model/FilterValues";
import { useOutsideClick } from "../../hooks/useOutsideClick";

/**
 * @author stcatai Mar 26, 2024
 */
export interface DateFilterProps {
  values: DateFilterValues;
  setValues: Dispatch<SetStateAction<DateFilterValues>>;
  setFetch: Dispatch<SetStateAction<DateFilterValues>>;
}

export default function DateFilter({values, setValues, setFetch}: DateFilterProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [fromDate, setFromDate] = useState<Date | undefined>(values.fromDate);
  const [toDate, setToDate] = useState<Date | undefined>(values.toDate);

  const contentRef = useRef(null);
  const openButtonRef = useRef(null);

  useOutsideClick([contentRef, openButtonRef], () => {
    if (isOpen)
      setIsOpen(false);
  });

  const submitValues = () => {
    setValues({fromDate: fromDate, toDate: toDate});
    setFetch({fromDate: fromDate, toDate: toDate});
    setIsOpen(false);
  }

  const clearValues = () => {
    setFromDate(undefined);
    setToDate(undefined);
    setValues({fromDate: undefined, toDate: undefined});
    setFetch({fromDate: undefined, toDate: undefined});
    setIsOpen(false);
  }

  return <div className="number-filter">
    <button className="open-button" onClick={() => setIsOpen(!isOpen)} ref={openButtonRef}>&#9660;</button>
    {isOpen && <div className="content" ref={contentRef}>

      <div className="calendars">
        <div className="calendar">
          <label htmlFor="from">From</label>
          <input type="date" id="from" value={fromDate?.toISOString().substring(0,10) ?? ""} onChange={(e) => setFromDate(new Date(e.target.value))}/>
        </div>

        <div className="calendar">
          <label htmlFor="less">To</label>
          <input type="date" id="to" value={toDate?.toISOString().substring(0,10) ?? ""} onChange={(e) => setToDate(new Date(e.target.value))}/>
        </div>
      </div>

      <div className="update-buttons">
        <button onClick={submitValues}>Set</button>
        <button onClick={clearValues}>Clear</button>
      </div>
    </div> }
  </div>
}